import { render, staticRenderFns } from "./RegistrasiPerusahaan.vue?vue&type=template&id=090ec899&"
import script from "./RegistrasiPerusahaan.vue?vue&type=script&lang=js&"
export * from "./RegistrasiPerusahaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports